export default "__VITE_ASSET__ITZSz5ye__"